import { Badge } from '@ps/isp-web-component-library';
import { Ninety } from '@ps/isp-web-component-library/icons/Ninety';
import { TwoUpIcon } from '@ps/isp-web-component-library/icons/TwoUpIcon';
import type { MarketType } from '@ps/isp-web-services-types';
import { getIsMatchOddsNinetyMarket, getIsTwoUpMarket } from '@ps/web-sports-utils';

import { useRegulatoryIntl } from '@swf/core/hooks/useRegulatoryIntl';

import { TXTWCL_Match_Odds_90, TXTWCL_Match_Odds___2_Up } from './MatchMarketIcons.messages.json';

interface Props {
  marketType?: MarketType;
  size?: string;
}

const MatchMarketIcons: React.FC<Props> = ({ marketType, size }) => {
  const { formatMessage } = useRegulatoryIntl();

  if (!marketType) {
    return null;
  }

  const matchOddsNinetyLabel = formatMessage(TXTWCL_Match_Odds_90);
  const twoUpMarketLabel = formatMessage(TXTWCL_Match_Odds___2_Up);
  const renderMatchOddsNinetyMarket = getIsMatchOddsNinetyMarket(marketType);
  const renderTwoUpMarket = getIsTwoUpMarket(marketType);

  if (!renderMatchOddsNinetyMarket && !renderTwoUpMarket) {
    return null;
  }

  return (
    <>
      {renderMatchOddsNinetyMarket && (
        <Badge
          icon={Ninety}
          iconLabel={matchOddsNinetyLabel}
          label={matchOddsNinetyLabel}
          size={size}
        />
      )}
      {renderTwoUpMarket && (
        <Badge icon={TwoUpIcon} iconLabel={twoUpMarketLabel} label={twoUpMarketLabel} size={size} />
      )}
    </>
  );
};

export { MatchMarketIcons };
